import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Steps } from 'tdesign-react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Panel from '@/components/Panel';
import { cacheStep, cleanCache, fetchComponentById } from '@/slices/templateSlice';
import { isEmpty } from '@/utils/common';
import BasicStep from './BasicStep';
import ParamsStep from './ParamsStep';
import PrecessStep from './PrecessStep';
import RollbackStep from './RollbackStep';
import UninstallStep from './UninstallStep';
import ConfirmStep from './ConfirmStep';
import RestartStep from './RestartStep';
import RunStatusStep from './RunStatusStep';
import StopStep from './StopStep';

const { StepItem } = Steps;

export const infos = [
  '1.下拉制品包到目标机器之前，在目标机器上执行的脚本',
  '2.下拉制品包到目标机器repo路径下（系统执行）',
  '3.制品包已部署到repo路径之后，在目标机器上执行的脚本',
  '4.将repo目录下的当前版本链接到服务提供的目录（系统执行）',
  '5.在目标机器上启动组件之前，在目标机器上执行的脚本',
  '6.在目标机器上启动组件之后，在目标机器上执行的脚本',
];

function Detail({ cacheStep, cache, cleanCache, fetchComponentById }) {
  const [currentStep, setCurrentStep] = useState(0);
  const { id } = useParams();
  const isEdit = !isEmpty(id);

  useEffect(() => {
    cleanCache();
    if (isEdit) {
      fetchComponentById(id);
    }
  }, [cleanCache, fetchComponentById, isEdit, id]);

  const nextStep = (data) => {
    cacheStep({ step: currentStep, data });
    setCurrentStep((step) => step + 1);
    document.querySelector('.body-container').scrollTo({ top: 0 });
  };

  const preStep = () => setCurrentStep((step) => step - 1);
  const currentCache = cache[currentStep];

  return (
    <Root>
      <Panel style={{ padding: 24 }}>
        <StepTitle>新建组件定义pulsar的一个新的组件：共分为以下9个步骤</StepTitle>
        <Steps current={currentStep} readonly>
          <StepItem icon title='基础信息' />
          <StepItem icon title='变量信息' />
          <StepItem icon title='部署/升级' />
          <StepItem icon title='回滚' />
          <StepItem icon title='卸载' />
          <StepItem icon title='(RE)START' />
          <StepItem icon title='STOP' />
          <StepItem icon title='进程状态' />
          <StepItem icon title='信息确认' />
        </Steps>
      </Panel>
      {currentStep === 0 && <BasicStep cache={currentCache} nextStep={nextStep} />}
      {currentStep === 1 && (
        <ParamsStep cache={currentCache} preStep={preStep} nextStep={nextStep} />
      )}
      {currentStep === 2 && (
        <PrecessStep cache={currentCache} preStep={preStep} nextStep={nextStep} />
      )}
      {currentStep === 3 && (
        <RollbackStep cache={currentCache} preStep={preStep} nextStep={nextStep} />
      )}
      {currentStep === 4 && (
        <UninstallStep cache={currentCache} preStep={preStep} nextStep={nextStep} />
      )}
      {currentStep === 5 && (
        <RestartStep cache={currentCache} preStep={preStep} nextStep={nextStep} />
      )}
      {currentStep === 6 && <StopStep cache={currentCache} preStep={preStep} nextStep={nextStep} />}
      {currentStep === 7 && (
        <RunStatusStep cache={currentCache} preStep={preStep} nextStep={nextStep} />
      )}
      {currentStep === 8 && <ConfirmStep cache={cache} preStep={preStep} nextStep={nextStep} />}
    </Root>
  );
}

export default connect(
  (state) => ({
    cache: state.template.cache,
  }),
  {
    cacheStep,
    cleanCache,
    fetchComponentById,
  },
)(Detail);

const Root = styled.div`
  padding-right: 20px;
  min-width: 1100px;
  .t-steps .t-steps-item__title {
    font-size: var(--td-font-size-body-medium);
  }
`;

const StepTitle = styled.div`
  font-size: 14px;
  color: var(--td-font-gray-2);
  margin-bottom: 20px;
`;
